<template>
  <el-form :model="retroForm" ref="retroForm" label-width="120px" class="demo-dynamic" label-position="top" v-loading="loading">
    <el-form-item class="retroForm" :label="$t('feed.settings.common.sourcesTitle')" prop="sources">
      <el-select v-model="retroForm.sources" class="retroForm" placeholder="Обход источников">
        <el-option :label="item.label" :value="item" v-for="item in perSources" :key="item.label"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="retroForm" :label="$t('feed.settings.common.profilesTitle')" prop="profiles">
      <el-select v-model="retroForm.profiles" placeholder="Обновление профилей">
        <el-option :label="item.label" :value="item" v-for="item in perProfiles" :key="item.label"></el-option>
      </el-select>
    </el-form-item>

    <div class="retro_comment">{{$t('feed.settings.common.retroDateTitle')}}:</div>
    <el-form-item>
      <ul class="retro-date-list">
        <li class="retro-date-list__item">
          <el-date-picker
            v-model="retroForm.date_retro"
            @change="handleChange"
            type="date"
            format="dd.MM.yyyy"
            :placeholder="$t('feed.settings.common.retroDate[0]')">
          </el-date-picker>
        </li>
        <li class="retro-date-list__item">
          <el-date-picker
            v-model="retroForm.date_retro_to"
            type="date"
            format="dd.MM.yyyy"
            :placeholder="$t('feed.settings.common.retroDate[1]')"
            :picker-options="{ disabledDate: (time) => disabledEndDate(time, departureDate) }"
            >
            
          </el-date-picker>
        </li>
      </ul>
    </el-form-item>

    <!-- <el-form-item class="retroForm" :label="$t('feed.settings.common.per_retroTitle')" prop="per_retro">
      <el-select v-model="retroForm.per_retro" placeholder="Сбор ретроспективы">
        <el-option :label="item.label" :value="item" v-for="item in perRetro" :key="item.label"></el-option>
      </el-select>
    </el-form-item> -->
  </el-form>
</template>

<script>
  // api
  import { threadGetPeriodsApi } from "../../../../../../api/feeds";

  // libraries
  import moment from 'moment';

  export default {
    name: "Retrospective",
    data() {
      return {
        perRetroCount: 0,
        loading: false,
        retroForm: {
          sources:  this.$t('feed.settings.common.retroDefault.sources'),
          profiles: this.$t('feed.settings.common.retroDefault.profiles'),
          date_retro: new Date(),
          date_retro_to: new Date(),
          per_retro: this.$t('feed.settings.common.retroDefault.per_retro'),
        },
        ...this.$t('feed.settings.common.retro'),
      };
    },
    computed: {

    },
    methods: {
      disabledEndDate(date, departureDate) {
        // If departureDate then return valid dates after departureDate
        if (departureDate) {
          return date.getTime() > departureDate
        } else {
          // If !departureDate then return valid dates after today
          return date.getTime() > Date.now()
        }
      },

      handleChange() {
        if (this.$t('feed.settings.common.retro.perRetro').length > this.perRetroCount) {
          this.$t('feed.settings.common.retro.perRetro').splice(-1,1);
        }

        let days = moment(this.retroForm.date_retro).diff(moment(), 'd');
        let retroString = this.$t('feed.settings.common.getRetro[0]') + ' ' + days + ' ' + this.$t('feed.settings.common.getRetro[1]');
        retroString = retroString.replace('-', '');

        this.retroForm.per_retro = {
          label: retroString,
          value: days
        };

        this.$t('feed.settings.common.retro.perRetro').push(this.retroForm.per_retro);
      },
      getData() {
        return this.retroForm;
      },
      getRetro() {
        let params = {
          thread_id: this.$route.params.threadId
        };
        this.loading = true;

        threadGetPeriodsApi(params).then(resp => {
          this.retroForm.date_retro = moment(resp.data.periods.retro).toDate();
          this.retroForm.date_retro_to = resp.data.periods.retro_max ? moment(resp.data.periods.retro_max).toDate() : null;

          if (resp.data.periods.sources) {
            this.retroForm.sources = {label: 'Совершать обход источников раз в ' + resp.data.periods.sources + ' минут', value: resp.data.periods.sources};
          }

          if (resp.data.periods.profiles) {
            this.retroForm.profiles = {label: 'Обновление профилей раз в ' + resp.data.periods.profiles + ' минут', value: resp.data.periods.profiles};
          }

          if (resp.data.periods.retro === 0) {
            this.retroForm.per_retro = {label: 'Наблюдение', value: 0};
          }

          this.loading = false;
        });
      },
    },
    mounted() {
      this.getRetro();
      this.perRetroCount = this.$t('feed.settings.common.retro.perRetro').length;
    }
  };
</script>

<style>
  .retro-date-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
  }
  .retro_comment {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 15px;
  }
  .retro-date-list__item {
    margin-bottom: 15px;
  }
  .retro-date-list__item:last-child {
    margin-bottom: 0;
  }

  .retroForm .el-select {
    display: block;
    width: 50%;
  }
  .retroForm .el-select .el-input {
    width: 100%;
  }
  @media screen and (max-width: 480px) {
    .retroForm .el-select {
      display: block;
      width: 100%;
    }
    .el-select-dropdown__item {
      font-size: 12px;
    }
  }
</style>
